import { ICON__square_regular } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { assert_instanceof, assert_true } from '@shared/asserts/utils_asserts';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { useMemo } from 'react';

interface PROPS {
  grid2d: DTO__grid2d;
  entity: DTO__entity_with_grid2d;
}

export function GRID2D_BUTTON__generation_reset_dimensions({ grid2d, entity }: PROPS) {
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  const can_reset_dimensions = useMemo(() => get_can_reset_dimensions(), [grid2d, entity, g_general__ui_disabled]);

  async function onClick() {
    assert_true(can_reset_dimensions);

    assert_instanceof(entity, DTO__generation);

    let graph_new = entity.tool.graph.clone();

    graph_new.grid2d__dimensions_reset_to_stub();

    await UTILS__graph_data.update(graph_new);
  }

  function get_can_reset_dimensions() {
    if (grid2d.is_stub()) return false;
    if (entity.is_stub()) return false;
    if (!(entity instanceof DTO__generation)) return false;
    if (g_general__ui_disabled) return false;

    let { invocation_grid2d_view } = entity.tool.graph;

    let field_grid2d_row = entity.tool.graph.grid2d__get_field_row();
    let field_grid2d_column = entity.tool.graph.grid2d__get_field_column();

    if (
      field_grid2d_row.meta.field_id == invocation_grid2d_view.stub_grid2d_row.meta.field_id &&
      field_grid2d_column.meta.field_id == invocation_grid2d_view.stub_grid2d_column.meta.field_id
    )
      return false;

    return true;
  }

  if (!can_reset_dimensions) return null;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant={'no-border-on-bar'}
      Icon={ICON__square_regular}
      renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
      {...{ onClick }}
      className="p-0 h-[28px] w-[30px] flex-center"
      iconClassNameBase="!text-component-item-foreground !size-3"
      iconClassNameHovered="!text-bar-foreground"
    />
  );
}
